import {
    GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_REQUEST,
    GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_SUCCESS,
    GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_ERROR
} from "../actions/types";

export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {


        case GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_REQUEST:
            return {
                loading: true,
            };
        case GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                payload
            };
        case GET_SHIPPED_DETAIL_BY_PAYMENT_METHOD_REPORT_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        default:
            return state;
    }
}
